export default __webpack_public_path__ + "static/media/backgroundv3.9604104e.jpg";